module.exports = __webpack_public_path__ + "static/gif-uma-vida-financeira-mobile-0a9ad4df39689bd41df861125a4420fc.gif";